// extracted by mini-css-extract-plugin
module.exports = {"module":"complex-entrance_module__31c90","title":"complex-entrance_title__213F5","floors":"complex-entrance_floors__XWb7V"};